import React from "react";
import { ChevronRight } from "lucide-react";

const METAL = [
  { ring: "from-[#FFF3C4] via-[#E7B84A] to-[#9C6B1A]", text: "text-amber-300", bg: "from-amber-500/15" },
  { ring: "from-white via-[#C9D2DE] to-[#7C8AA3]", text: "text-slate-200", bg: "from-slate-300/10" },
  { ring: "from-[#FCE1C8] via-[#D9925A] to-[#7A3E17]", text: "text-orange-300", bg: "from-orange-500/10" },
];

function Avatar({ initials, avatar, ring }) {
  return (
    <div className={`p-[2px] rounded-full bg-gradient-to-br ${ring}`}>
      {avatar ? <img src={avatar} alt="" className="w-12 h-12 rounded-full object-cover bg-slate-900" onError={e => { e.target.style.display = "none"; }} />
        : <div className="w-12 h-12 rounded-full bg-slate-950 text-white text-sm font-extrabold flex items-center justify-center">{initials}</div>}
    </div>
  );
}

/** Classifica: stessi dati e ordinamento ricevuti dal chiamante; solo presentazione (podio 1-3 + righe 4-5). */
export function Podium({ title, sub, items, emptyText, onAll, testid }) {
  const top = items.slice(0, 3), rest = items.slice(3, 5);
  return (
    <div className="rounded-2xl border border-slate-800/80 bg-slate-900/40 p-5" data-testid={testid}>
      <div className="flex items-center justify-between mb-4">
        <div><div className="font-display text-lg font-bold text-white">{title}</div><div className="text-[11px] text-slate-500">{sub}</div></div>
        {onAll && <button type="button" onClick={onAll} className="text-xs text-amber-400 hover:text-amber-300 font-bold flex items-center gap-1" data-testid={`${testid}-all`}>Vedi tutti<ChevronRight size={12} /></button>}
      </div>
      {items.length === 0 ? <div className="text-slate-500 text-sm text-center py-8">{emptyText}</div> : (
        <>
          <div className="grid grid-cols-3 gap-2">
            {top.map((it, i) => (
              <button key={it.key} type="button" onClick={it.onClick} disabled={!it.onClick} data-testid={`${testid}-podium-${i + 1}`}
                className={`relative rounded-xl border border-slate-800 bg-gradient-to-b ${METAL[i].bg} to-transparent p-3 flex flex-col items-center text-center hover:border-amber-500/40 transition-colors`}>
                <span className={`absolute top-2 left-2 w-5 h-5 rounded-md bg-gradient-to-br ${METAL[i].ring} text-[10px] font-black text-black flex items-center justify-center`}>{i + 1}</span>
                <Avatar initials={it.initials} avatar={it.avatar} ring={METAL[i].ring} />
                <div className="mt-2 text-xs font-bold text-white line-clamp-2 min-h-[2rem]">{it.name}</div>
                <div className="text-[10px] text-slate-500">{it.sub}</div>
                <div className={`mt-1 font-mono-num text-sm font-extrabold ${METAL[i].text}`}>{it.amount}</div>
              </button>
            ))}
          </div>
          {rest.length > 0 && (
            <div className="mt-3 divide-y divide-slate-800/60 rounded-xl border border-slate-800/60">
              {rest.map((it, i) => (
                <button key={it.key} type="button" onClick={it.onClick} disabled={!it.onClick} data-testid={`${testid}-row-${i + 4}`}
                  className="w-full text-left px-3 py-2 flex items-center gap-3 hover:bg-slate-900/60">
                  <span className="w-5 text-center text-xs font-bold text-slate-400">{i + 4}</span>
                  <span className="flex-1 min-w-0 text-sm text-white truncate">{it.name}</span>
                  <span className="text-[11px] text-slate-500">{it.sub}</span>
                  <span className="font-mono-num text-sm font-bold text-amber-400 w-24 text-right">{it.amount}</span>
                </button>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
